import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import { useAuth } from '../../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Error during auth callback:', error.message);
          navigate('/login', {
            state: { message: 'Authentication failed. Please try again.' }
          });
          return;
        }

        if (session?.user) {
          const userData = {
            id: session.user.id,
            email: session.user.email,
            displayName: session.user.user_metadata.full_name,
            photoURL: session.user.user_metadata.avatar_url
          };
          
          setUser(userData);
          navigate('/dashboard');
        } else {
          navigate('/login');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', {
          state: { message: 'Authentication failed. Please try again.' }
        });
      }
    };

    handleAuthCallback();
  }, [navigate, setUser]);

  return <div>Completing authentication...</div>;
};

export default AuthCallback; 